import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './components/header/Header';
import Cards from './components/cards/Cards';
import Sobremim from './components/sobremim/Sobremim';
import Services from './components/services/Services';
import Garantia from './components/garantia/Garantia';
import Depoimentos from './components/depoimentos/Depoimentos';
import Perguntas from './components/perguntas/Perguntas';
import Tabela from './components/tabela/Tabela';
import Pagamento from './components/pagamento/Pagamento';
import Entrega from './components/entrega/Entrega';
import Rodape from './components/rodape/Rodape';
import ButtonWhatsap from './components/button_whatsap/ButtonWhatsap';

export default function Home() {
  return (
    <div>
      {/* ================= SEO e Compartilhamento ================= */}
      <Helmet>
        {/* Título */}
        <title>Wellington | Manutenção de Computadores em Pilar do Sul</title>

        {/* Descrição */}
        <meta
          name="description"
          content="Manutenção de computadores em Pilar do Sul. SSD, memória, formatação e conserto de PCs lentos ou travando. Atendimento rápido, confiável e profissional!"
        />

        {/* Palavras-chave para SEO */}
        <meta
          name="keywords"
          content="manutenção de computadores, conserto de PC, Pilar do Sul, SSD, memória, formatação, PC lento, PC travando, Wellington manutenção"
        />

        {/* Open Graph - Facebook/Instagram/WhatsApp */}
        <meta property="og:title" content="Wellington | Manutenção de Computadores em Pilar do Sul" />
        <meta property="og:description" content="Seu PC travando ou lento? Posso ajudar com SSD, memória ou formatação. Atendimento rápido e confiável!" />
        <meta property="og:image" content="https://seusite.com.br/imagem-preview.jpg" />
        <meta property="og:url" content="https://wellington-miranda-manutencao.vercel.app/" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Wellington | Manutenção de Computadores em Pilar do Sul" />
        <meta name="twitter:description" content="Seu PC travando ou lento? Posso ajudar com SSD, memória ou formatação. Atendimento rápido e confiável!" />
        <meta name="twitter:image" content="https://seusite.com.br/imagem-preview.jpg" />

        {/* Verificação Google Search Console (se quiser usar meta) */}
        <meta name="google-site-verification" content="google6e6211c4ba82f5ba" />
      </Helmet>

      {/* ================= Conteúdo da Página ================= */}
      <Header />

      {/* Cards de serviços - reforçando palavras-chave */}
      <Cards />

      {/* Sobre Mim */}
      <Sobremim>
        <p>
          Olá, sou Wellington. Atuo em <strong>Pilar do Sul</strong> com manutenção de computadores. 
          Se seu PC está lento, travando ou precisa de <strong>SSD, memória ou formatação</strong>, 
          posso te ajudar de forma rápida e confiável.
        </p>
      </Sobremim>

      {/* Serviços detalhados */}
      <Services />

      {/* Garantia */}
      <Garantia />

      {/* Depoimentos */}
      <Depoimentos />

      {/* Perguntas Frequentes */}
      <Perguntas />

      {/* Tabela de preços */}
      <Tabela />

      {/* Pagamento */}
      <Pagamento />

      {/* Entrega */}
      <Entrega />

      {/* Rodapé */}
      <Rodape />

      {/* Botão flutuante WhatsApp */}
      <ButtonWhatsap />
    </div>
  );
}
